/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FromNowPipe } from '@src/app/shared/pipes/from-now.pipe';
import { MatTooltip } from '@angular/material/tooltip';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-date-time-item',
    imports: [MatIconModule, FromNowPipe, MatTooltip, DatePipe],
    templateUrl: './date-time-item.component.html',
    styleUrl: '../simple-fields.scss'
})
export class DateTimeItemComponent {
    @Input() label: string
    @Input() date: number;
    @Output() editor = new EventEmitter<null>();
}
